import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, errorMsg } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export const CargarEnCotizacionDialog = ({ plantilla, onClose }) => {
  const navigate = useNavigate();
  const [misCots, setMisCots] = useState([]);
  const [nombreNuevaCot, setNombreNuevaCot] = useState("");

  useEffect(() => {
    if (!plantilla) return;
    setNombreNuevaCot("");
    api.get("/cotizaciones").then((r) => setMisCots(r.data)).catch(() => {});
  }, [plantilla]);

  const irConOpcionales = (cotId) => {
    const opcionales = (plantilla.items_efectivos || plantilla.items || []).filter((it) => it.opcional);
    navigate(`/cotizaciones/${cotId}`,
      opcionales.length ? { state: { opcionales: { titulo: plantilla.nombre, items: opcionales } } } : undefined);
  };

  const cargarEnCotizacion = async (cotId) => {
    try {
      await api.post(`/cotizaciones/${cotId}/cargar-plantilla?plantilla_id=${plantilla.id}`);
      toast.success(`Plantilla "${plantilla.nombre}" cargada`);
      irConOpcionales(cotId);
    } catch (e) {
      if (e.response?.status === 409) {
        if (window.confirm(errorMsg(e))) {
          await api.post(`/cotizaciones/${cotId}/cargar-plantilla?plantilla_id=${plantilla.id}&confirmar=true`);
          irConOpcionales(cotId);
        }
      } else toast.error(errorMsg(e));
    }
  };

  const crearYCargar = async () => {
    try {
      const { data } = await api.post("/cotizaciones", { nombre: nombreNuevaCot });
      await cargarEnCotizacion(data.id);
    } catch (e) { toast.error(errorMsg(e)); }
  };

  return (
    <Dialog open={!!plantilla} onOpenChange={onClose}>
      <DialogContent className="bg-white">
        <DialogHeader><DialogTitle>Cargar "{plantilla?.nombre}" en una cotización</DialogTitle></DialogHeader>
        <div className="space-y-3">
          <div className="flex gap-2">
            <Input data-testid="nueva-cot-desde-plantilla-input" placeholder="Nombre de nueva cotización..." value={nombreNuevaCot} onChange={(e) => setNombreNuevaCot(e.target.value)} />
            <Button data-testid="crear-cot-desde-plantilla-btn" onClick={crearYCargar} disabled={!nombreNuevaCot.trim()}>Crear y cargar</Button>
          </div>
          {misCots.length > 0 && (<>
            <p className="text-xs text-muted-foreground">O elige una cotización existente:</p>
            <div className="space-y-1 max-h-52 overflow-y-auto">
              {misCots.map((c) => (
                <button key={c.id} data-testid={`cargar-en-cot-${c.id}`}
                  className="w-full text-left border border-border rounded-sm px-3 py-2 text-sm hover:bg-secondary"
                  onClick={() => cargarEnCotizacion(c.id)}>
                  {c.nombre} <span className="text-xs text-muted-foreground">({c.fecha_creacion ? c.fecha_creacion.slice(0, 10).split("-").reverse().join("/") : ""})</span>
                </button>
              ))}
            </div>
          </>)}
        </div>
      </DialogContent>
    </Dialog>
  );
};
